// extracted by mini-css-extract-plugin
export default {"actions":"Codigos_actions__Q1ITe","download":"Codigos_download__KKbqV","year":"Codigos_year__S20ff","codigo":"Codigos_codigo__go9V7"};